var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containerDiv"},[_c('PCNavbar',{attrs:{"selectIndex":"telMsg"}}),_c('MobileNavBar',{attrs:{"currentActive":10}}),_c('img',{staticClass:"bannerImgcss0",attrs:{"src":require("../assets/bannner/lianxiwomen.png")}}),_c('telMsg')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }